var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 3.41675C2.91928 3.41675 2.5835 3.75254 2.5835 4.16675C2.5835 4.58096 2.91928 4.91675 3.3335 4.91675L16.6668 4.91675C17.081 4.91675 17.4168 4.58096 17.4168 4.16675C17.4168 3.75253 17.081 3.41675 16.6668 3.41675L3.3335 3.41675ZM2.5835 10.0001C2.5835 9.58587 2.91928 9.25008 3.3335 9.25008L16.6668 9.25008C17.081 9.25008 17.4168 9.58587 17.4168 10.0001C17.4168 10.4143 17.081 10.7501 16.6668 10.7501L3.3335 10.7501C2.91928 10.7501 2.5835 10.4143 2.5835 10.0001ZM2.5835 15.8334C2.5835 15.4192 2.91928 15.0834 3.3335 15.0834L16.6668 15.0834C17.081 15.0834 17.4168 15.4192 17.4168 15.8334C17.4168 16.2476 17.081 16.5834 16.6668 16.5834L3.3335 16.5834C2.91928 16.5834 2.5835 16.2476 2.5835 15.8334Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBurgerMenu);
export default __webpack_public_path__ + "static/media/ic_burger_menu.783721d7.svg";
export { ForwardRef as ReactComponent };